import * as THREE from 'three';
import type { GameConfig } from '../types/GameConfig';

export class TopDownCamera {
  readonly camera: THREE.OrthographicCamera;
  private frustumHalf: number;
  private readonly zoomMin: number;
  private readonly zoomMax: number;
  private aspect: number = 1;

  constructor(config: Pick<GameConfig, 'cameraHeight' | 'zoomMin' | 'zoomMax' | 'zoomDefault'>) {
    this.frustumHalf = config.zoomDefault;
    this.zoomMin = config.zoomMin;
    this.zoomMax = config.zoomMax;

    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 1000);
    this.camera.position.set(0, config.cameraHeight, 0);
    // Look straight down: up vector must be a non-parallel axis
    this.camera.lookAt(0, 0, 0);
    // For a top-down view, set up vector to point along -Z so north is up in screen space
    this.camera.up.set(0, 0, -1);
    this.camera.lookAt(0, 0, 0);
  }

  updateAspect(width: number, height: number): void {
    this.aspect = width / height;
    this.applyFrustum();
  }

  zoom(delta: number): void {
    this.frustumHalf = THREE.MathUtils.clamp(
      this.frustumHalf + delta,
      this.zoomMin,
      this.zoomMax
    );
    this.applyFrustum();
  }

  pan(dx: number, dy: number): void {
    this.camera.position.x += dx;
    this.camera.position.z += dy;
  }

  clampToBounds(halfGroundSize: number): void {
    this.camera.position.x = THREE.MathUtils.clamp(
      this.camera.position.x,
      -halfGroundSize,
      halfGroundSize
    );
    this.camera.position.z = THREE.MathUtils.clamp(
      this.camera.position.z,
      -halfGroundSize,
      halfGroundSize
    );
  }

  private applyFrustum(): void {
    const h = this.frustumHalf;
    const w = h * this.aspect;
    this.camera.left = -w;
    this.camera.right = w;
    this.camera.top = h;
    this.camera.bottom = -h;
    this.camera.updateProjectionMatrix();
  }
}
